// extracted by mini-css-extract-plugin
export var cardsWrapper = "GreenValues-module--cardsWrapper--01694";
export var fadeInAnimation = "GreenValues-module--fadeInAnimation--594f7";
export var layout = "GreenValues-module--layout--4d9db";